import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { AxiosResponse } from 'axios'

const confirmReceiveDocument = async (claimFormId: string): Promise<AxiosResponse> => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}/document/recieved`,
    {},
  )
  return response.data
}

const useConfirmReceiveDocument = () => {
  const mutationKey = ['useConfirmReceiveDocument']
  return useMutation({
    mutationKey,
    mutationFn: confirmReceiveDocument,
  })
}

export { useConfirmReceiveDocument }
